export default __webpack_public_path__ + "static/media/document-duplicate.c9314938.svg";